import React from "react";
import {
  MDBBtn,
  MDBListGroup,
  MDBListGroupItem,
  MDBRipple,
} from "mdb-react-ui-kit";
import { AiOutlineSearch } from "react-icons/ai";
import "../../css/ListSearchCard.css";

function ListSearchCard({
  title,
  setEmployeeQuery,
  employeeQuery,
  setShowSuggestionsFlag,
  showSuggestionsFlag,
  employeeData,
  selectEmployee,
  suggestionToQuery,
  clearEmployeeQuery,
}) {
  function scrollToDivWithOffset() {
    const someDiv = document.getElementById("empDetails");
    if (someDiv) {
      const rect = someDiv.getBoundingClientRect();
      window.scrollBy(0, rect.top - 100);
      return;
    }
    window.scrollTo(0, document.body.scrollHeight);
  }

  const selectEmployeeCall = async (e) => {
    e.preventDefault();

    if (employeeQuery !== "" && employeeQuery !== " ") {
      selectEmployee(e);
      clearEmployeeQuery(false);

      document.getElementById("empName").disabled = true;

      setTimeout(() => {
        scrollToDivWithOffset();
      }, 500);
      return;
    }

    clearEmployeeQuery(true);
  };

  return (
    <div className="searchCardDiv">
      <h1>{title}</h1>

      <div className="searchBoxDiv">
        <div>
          <input
            className="searchBox"
            placeholder="Please Select an Employee"
            id="empName"
            type="text"
            onChange={(e) => {
              setEmployeeQuery(e.target.value);
              if (employeeQuery === " " || employeeQuery === "")
                setShowSuggestionsFlag(false);
              else setShowSuggestionsFlag(true);
            }}
          />
          <button
            id="toggle"
            className="searchBoxCancel"
            color="none"
            onClick={() => clearEmployeeQuery(true)}
          >
            X
          </button>
        </div>
        <MDBBtn
          className="searchButton"
          onClick={
            //clearEmployeeQuery();
            selectEmployeeCall
          }
        >
          Search
        </MDBBtn>
        <MDBBtn
          className="searchButtonIcon"
          onClick={
            //clearEmployeeQuery();
            selectEmployeeCall
          }
        >
          <AiOutlineSearch />
        </MDBBtn>
      </div>
      <div className="searchListContainer" id="searchList">
        <div className="searchListDiv">
          <MDBListGroup>
            {employeeData &&
              employeeData
                .filter((emp) => {
                  if (
                    !employeeQuery ||
                    employeeQuery === " " ||
                    employeeQuery === ""
                  )
                    return true;
                  else
                    return emp.name
                      .toLowerCase()
                      .includes(employeeQuery.toLowerCase());
                })
                .map((emp, index) => {
                  return (
                    <MDBRipple key={index} className="searchListItem">
                      <MDBListGroupItem
                        key={index}
                        tag="a"
                        action
                        onClick={(e) => {
                          //console.log(emp.employee_id);
                          suggestionToQuery(emp.name, emp["employee id"]);
                        }}
                      >
                        {emp.name}
                      </MDBListGroupItem>
                    </MDBRipple>
                  );
                })}
          </MDBListGroup>
        </div>

        <MDBBtn className="searchButton" style={{ visibility: "hidden" }}>
          Search
        </MDBBtn>
        <MDBBtn className="searchButtonIcon" style={{ visibility: "hidden" }}>
          <AiOutlineSearch />
        </MDBBtn>
      </div>
    </div>
  );
}

export default ListSearchCard;
